import "../../CommonImports";
import "../../Core/core.css";
import "./ButtonGroup.css";
import * as React from "react";
import { css } from '../../Util';
export const ButtonGroup = (props) => {
    return (React.createElement("div", { className: css(props.className, "bolt-button-group flex-row"), role: props.role }, props.children));
};
